export const COHORTS = {
	NOT_ENROLLED: 'not_enrolled',
	CONTROL: 'control',
	TREATMENT: 'treatment',
} as const;

export type CohortValues = (typeof COHORTS)[keyof typeof COHORTS];
